import React from 'react'
// import {PIcon} from 'components/vectors';
import * as moment from 'moment'


const PlayspreadListItem = ({subsource,song,amount,artist_name, detected_time, image}) => (
    // <div className="row mx-0 list-item">
    //     <div className="col-md-3 pl-0">
    //         <div className="d-flex flex-row">
    //             {/* <PIcon width={16} height={16} /> */}
    //             <p className="text--xs text--grey ml-3 text-left">{subsource}</p>
    //         </div>
    //     </div>
    //     <div className="col-md-2"><p className="text--xs text--grey text-center">{artist_name}</p></div>
    //     <div className="col-md-3"><p className="text--xs text--grey text-left">{song}</p></div>
    //     <div className="col-md-3"><p className="text--xs text--grey text-left">{moment(detected_time).format("dddd, MMMM Do YYYY, h:mm:ss a")}</p></div>
    //     <div className="col-md-1"><p className="text--xs text--grey text-center text-uppercase">{amount}</p></div>


    // </div>
    <tr className="list-item">
      {/* <td colSpan="3" className="text--xs text--grey ml-3 text-left">{subsource}</td> */}
      <td colSpan="3" className="text--xs text--grey ml-3 text-left">
      <div className="d-flex flex-row align-items-center">
                {/* <PIcon width={16} height={16} /> */}
                <img className="icon playspread-icon" src={`/images/logos/${image}`} alt="" />
                <p className="text--xs text--grey ml-3 text-left">{subsource}</p>
            </div>
      </td>
      <td colSpan="2" className="text--xs text--grey text-center">{artist_name}</td>
      <td colSpan="3" className="text--xs text--grey text-left">{song}</td>
      <td colSpan="3" className="text--xs text--grey text-left">{moment(detected_time).format("dddd, MMMM Do YYYY, h:mm:ss a")}</td>
      <td colSpan="1" className="text--xs text--grey text-center text-uppercase">{amount}</td>
    </tr>
)

export default PlayspreadListItem;